<template>
    <div>
        <div v-if="products.length">

            <div class="deal-form-title mb-15">
                Your products for this {{ interval }}.
            </div>

            <products-compensation-list-item
                v-for="(product, index) in products"
                :key="`${index}-${product.id}`"
                :product="product"
                :is-deal="campaign.type === 'deal'"
                :show-prices="!!settings.show_prices"
                :currency="campaign.brand.currency"
                :allow-select="false"
                :read-only="true"
            />

            <div class="mt-20" v-if="allowedToSelect">
                <button class="button" @click="handleEdit">
                    Change {{ campaign.select_products ? 'Products' : 'Options' }}
                </button>
            </div>
        </div>

        <div v-else>
            <blank-state :inner="true" size="small" icon="shopping-basket" v-if="allowedToSelect">
                <div slot="title">Choose Your Products</div>
                <div slot="content">
                    You have not selected any products for this {{ campaign.duration_interval }}.
                    <div class="mt-20">
                        <button class="button" @click="handleEdit">
                            Get Started
                        </button>
                    </div>
                </div>
            </blank-state>
            <blank-state :inner="true" size="small" icon="shopping-basket" v-else>
                <div slot="title">Your Products</div>
                <div slot="content">
                    Your products for the {{ campaign.duration_interval }} will show up here once they have been selected
                </div>
            </blank-state>
        </div>
    </div>
</template>

<script>
    import ProductsCompensationListItem from './ProductsCompensationListItem.vue';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'ProductsCompensationSelected',

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            ProductsCompensationListItem
        },

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type:     Object,
                required: true
            },

            /**
             * A deal's proposal
             */
            proposal: {
                type:     Object,
                required: true
            },

            /**
             * Selected products
             */
            products: {
                type:     Array,
                required: true
            }
        },

        /**
         * The computed properties
         *
         * @type {Object}
         */
        computed: {

            /**
             * The interval
             *
             * @returns {string}
             */
            interval() {
                return (this.campaign.partnership_type === 'promotion' ? 'partnership' : this.campaign.duration_interval);
            },

            /**
             * The compensation settings
             *
             * @returns {Object}
             */
            settings() {
                return this.proposal.compensation_settings;
            },

            /**
             * Whether or not a user is allowed to select products or options
             *
             * @returns {Boolean}
             */
            allowedToSelect() {
                if (this.settings.select_products) {
                    return true;
                }

                for (let i in this.products) {
                    if (this.products[i].select_options) {
                        return true;
                    }
                }

                return false;
            }
        },

        /**
         * The component methods
         *
         * @type {Object}
         */
        methods: {
            /**
             * Handle the "edit" event
             */
            handleEdit() {
                this.$emit('edit');
            }
        }
    }
</script>